import { FC, useEffect, useState } from 'react'

import { useLocation } from '@tanstack/react-router'

import { Logo, Stack, Typography } from '@forto-dev/phoenix-ui-core/common'
import { Splash } from '@forto-dev/phoenix-ui-core/ship'

import { useLocalisation } from '@/utils/localisation'

import { RequestResetPasswordForm } from './requestResetPassword.form'
import { ResetPasswordForm } from './resetPassword.form'
import { ResetPasswordRouteSearchParams } from './route'

export const ResetPassword: FC = () => {
  const { translate } = useLocalisation()
  const [resetPasswordParams, setResetPasswordParams] = useState<ResetPasswordRouteSearchParams>()
  const { search } = useLocation()
  const shouldShowUpdatePasswordForm =
    resetPasswordParams && !Object.values(resetPasswordParams).some((value) => value === undefined)

  useEffect(() => {
    setResetPasswordParams({
      customer_id: search.customer_id,
      user_id: search.user_id,
      digest: search.digest,
      expiry: search.expiry,
    })
  }, [search])

  if (shouldShowUpdatePasswordForm) {
    return (
      <Splash>
        <Stack gap={16}>
          <Logo />
          <Stack gap={4}>
            <Typography variant="h3">{translate('reset-password.title')}</Typography>
            <Typography variant="body">{translate('reset-password.update.intro.intro')}</Typography>
          </Stack>
          <ResetPasswordForm resetPasswordParams={resetPasswordParams} />
        </Stack>
      </Splash>
    )
  }

  return (
    <Splash>
      <Stack gap={16}>
        <Logo />
        <Stack gap={4}>
          <Typography variant="h3">{translate('reset-password.title')}</Typography>
          <Typography variant="body">{translate('reset-password.intro')}</Typography>
        </Stack>
        <RequestResetPasswordForm />
      </Stack>
    </Splash>
  )
}
